import styled from "styled-components"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"

const AdditionalInfos = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  color: ${(props) => props.theme.a_color_gradients.a_light};
`
const EventImg = styled.div`
  &::before {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const EventDate = styled.p`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const EventTaxo = styled.span`
  & > a {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
    text-decoration: none;
    font-weight: 600;
  }
`

const EventTitle = styled.h1`
  &::before {
    content: "// ";
    color: ${(props) => props.theme.a_color_gradients.a_dark};
    background-color: transparent !important;
  }
}
`

const EventFooterContainer = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  font-weight: bold;
  & a::before {
    background-color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`
const EventPlaceIcon = styled(Icon)`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const EventPlaceTitle = styled.p`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const EventItemRecurrence = styled.p`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export {
  AdditionalInfos,
  EventImg,
  EventDate,
  EventTaxo,
  EventTitle,
  EventPlaceIcon,
  EventPlaceTitle,
  EventFooterContainer,
  EventItemRecurrence,
}
